angular.module('jv.candidates.viewfields.factory', [])
    .factory('jvCandidatesViewfieldsFactory', ['$rootScope', 'jvCandidatesService', function($rootScope, jvCandidatesService) {
        var _candidateViewfields = {};
        return {
            setCandidateViewFields: function(applicationId, readmode, callback) {
                var args = {
                    applicationId: applicationId,
                    readMode: readmode
                };

                jvCandidatesService.getCandidateDetailsForApplication(args, function(response) {
                    if (response && angular.isDefined(response.data) && response.status === 200) {
                        _candidateViewfields[applicationId] = response.data.viewFields;
                        var offset = 0;
                        angular.forEach(_candidateViewfields[applicationId], function(field, index) {
                            if ($.inArray(field.fieldId, [-15, -16, -61]) >= 0) {
                                _candidateViewfields[applicationId].splice(index + offset, 1);
                                offset += 1;
                            }
                        });
                        callback(_candidateViewfields[applicationId]);
                        //TODO: Need to make this as pub-sub mechanism. 
                        $rootScope.$emit('candidate_view_fields_factory_updated');
                    }
                });
            },

            getCandidateViewFields: function(applicationId, readmode, callback, localFetch) {
                var mode;
                if (!readmode) {
                    mode = 1;
                } else {
                    mode = readmode.readMode;
                }

                if (mode) {
                    if (mode === true) {
                        mode = 0;
                    }
                } else {
                    if (mode !== 0) {
                        mode = 1;
                    }
                }

                if (angular.isDefined(_candidateViewfields[applicationId]) && (localFetch || mode === 1)) {
                    callback(_candidateViewfields[applicationId]);
                } else {
                    this.setCandidateViewFields(applicationId, mode, function() {
                        callback(_candidateViewfields[applicationId]);
                    });
                }
            }
        };
    }]);
